import { render, staticRenderFns } from "./Commodity.vue?vue&type=template&id=3c1c5c32&scoped=true&"
import script from "./Commodity.vue?vue&type=script&lang=js&"
export * from "./Commodity.vue?vue&type=script&lang=js&"
import style0 from "./Commodity.vue?vue&type=style&index=0&id=3c1c5c32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1c5c32",
  null
  
)

export default component.exports